import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import arrowUp from './arrow-up.svg';
import arrowDown from './arrow-down.svg';

interface Props {
  children: JSX.Element | string;
  title: JSX.Element;
  image?: {
    src: string;
    alt: string;
  };
  isUpcomingBenefit?: boolean;
  defaultIsOpen?: boolean;
}

const ImageAccordion: React.FC<Props> = (props: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(props.defaultIsOpen ?? false);

  const { t } = useTranslation('common');

  return (
    <div
      className={`border-2 rounded my-8 py-4 border-gray-500 ${
        props.isUpcomingBenefit ? 'bg-gray-400' : 'bg-white'
      }`}
    >
      <div className='p-5'>
        <div className='lg:flex justify-between'>
          {/* Note: the apartment image is shown in different places in mobile and desktop */}
          {props.image && (
            <img
              src={props.image.src}
              alt={props.image.alt}
              className='hidden md:block w-full h-40 object-cover lg:w-5/12 md:h-44 lg:h-56'
            />
          )}
          <div
            className={`flex flex-row items-center align-center justify-center ${
              props.image ? 'lg:w-7/12 lg:pl-8' : 'lg:w-full'
            } `}
          >
            {props.title}

            <img
              className='cursor-pointer h-5 w-5 ml-auto'
              onClick={() => setIsOpen(!isOpen)}
              src={isOpen ? arrowUp : arrowDown}
              alt={
                isOpen
                  ? t('Close', { ns: 'common' }) ?? 'Close'
                  : t('Open', { ns: 'common' }) ?? 'Open'
              }
            />
          </div>
        </div>

        <span className={isOpen ? '' : 'hidden'}>
          <hr className='border-gray-500 my-4 border-1' />
          {props.image && (
            <img
              src={props.image.src}
              alt={props.image.alt}
              className='block md:hidden w-full h-40 object-cover'
            />
          )}
          {props.children}
        </span>
      </div>
    </div>
  );
};

export default ImageAccordion;
